import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, TemplateRef, OnDestroy, Output, EventEmitter, DoCheck, ChangeDetectionStrategy } from '@angular/core';
// import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';

import { Subscription } from 'rxjs';

import { TableColumn } from '../models/tableColumn';
import { TableConfiguration } from '../models/tableConfiguration';
import { ColumnType } from '../models/columnType';
import { PagingAttributes } from 'src/swagger-gen/web-secured/models';
import { PaginationService } from '../pagination/pagination.service';

import { AlertService } from 'src/app/services';
import { AlertType } from 'src/app/shared/models/models-index';
import { ColumnToNotDisplay } from 'src/app/enums/ColumnsToNotDisplay';


@Component({
    selector: 'app-tinea-table',
    templateUrl: './tinea-table.component.html',
    styleUrls: ['./tinea-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TineaTableComponent implements OnInit, OnDestroy, OnChanges {

  /**
   * List of table column set in parent component
   */
  @Input() tableColumns: TableColumn[] = [];

  @Input() selectedTagsByDefault: string[];
  /**
   * Table configuration set in parent component
   */
  @Input() tableConfiguration: TableConfiguration;

  @Input() data: any;

  @Input() isLoadingItems: boolean = null;

  @Input() columnsToNotDisplay: ColumnToNotDisplay;

  /**
   * Table data transmitted from parent component
   */
  @Input() tableData = null; // TODO: set type?

  @Output() pageNumber = new EventEmitter<number>();

  @Output() paginating = new EventEmitter<'prev' | 'next' | 'prev-event' | 'next-event'>();

  @Output() eventOnClick = new EventEmitter<any>();
  /**
   * Enum import
   */
  columnTypes = ColumnType;

  /** Items with details shown by clicking on more */
  expandedItems = [];

  /** Uids of items selected by clicking on row checkbox */
  selectedItems: string[] = [];

  /** Pagination */
  page    = 1;
  totalPages: number;
  currentTotal = 50;
  paging: PagingAttributes;

  /* Subscriptions */
  dataSubscription: Subscription = new Subscription();
  public subscriptions: Subscription[] = [];

  /**
   * True by default & then while waiting for backend response
   */
  loadingItems = false;

  /**
   * Backend returned no data
   */
  noDataFound = false;

  /**
   * Current application language
   */
  language: 'fr' | 'en' = 'fr';

  /**
   * Date format to display depending of language
   */
  dateFormat: string;

  // /**
  //  * Delete confirmation modal
  //  */
  // @ViewChild('deleteAlert', {static: false}) deleteAlert!: TemplateRef<any>;
  // dialogRef: MatDialogRef<any, any>;

  constructor(
    public notificationService: AlertService,
    private paginationService: PaginationService,
    // public dialog: MatDialog
    ) { }

  ngOnInit() {
    this.setDateFormat();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes in tinea table', changes); // DEBUG
    if (!!changes.tableData && !!changes.tableData.currentValue) {
      // this.loadingItems = false;
      if (changes.tableData.currentValue.paging.totalItems === 0) {
        this.noDataFound = true;
      }
      this.page = 1;
      this.paging = changes.tableData.currentValue.paging;
      this.currentTotal = changes.tableData.currentValue.paging.curItems + changes.tableData.currentValue.paging.offset;
      this.totalPages = this.getTotalPagination();
      this.expandedItems = [];
    }

    if (!!changes.tableColumns && !!changes.tableColumns.currentValue) {
      const s = this.tableColumns[0].displayed;
      this.tableColumns = this.tableColumns.slice();
    }

    // if (changes.isLoadingItems && changes.isLoadingItems.currentValue) {
    //   if (changes.isLoadingItems.currentValue === true) {
    //     this.loadingItems = true;
    //   } else if (changes.isLoadingItems.currentValue === false) {
    //     this.loadingItems = false;
    //   }
    // }
  }

  /**
   * Set the date format depending on the language
   */
  setDateFormat() {
    if (this.language === 'fr') {
      this.dateFormat = 'dd/MM/yy HH:mm:ss';
    } else {
      this.dateFormat = 'MM/dd/yy HH:mm:ss';
    }
  }

  /********************************************** Selection & details ******************************/
  /**
   * Toggle extra data for this item by clicking on More-Less icon
   * @param uid selected item uid
   */
  showMoreOrLess(uid: string) {
    this.expandedItems[uid] = !this.expandedItems[uid];
  }

  /**
   * Push item to selected items list
   * @param uid item uid
   * @param add if should add or remove
   */
  pushToSelected(uid: string, add: boolean) {
    // console.log(this.selectedItems.includes(uid));
    add ? this.selectedItems.push(uid) : this.selectedItems.splice(this.selectedItems.indexOf(uid), 1);
    // console.log('this.selectedItems', this.selectedItems);
  }

  isSelected(uid: string) {
    // console.log(this.selectedItems.includes(uid));
    return this.selectedItems.includes(uid);
  }

  /********************************************** PAGINATION ******************************/
  /**
   * When user wants to go on previous page
   */
  onPrevPagination() {
    // console.log('in prev pagination',  this.page);
    if (this.page > 1) {
      this.currentTotal = this.currentTotal - this.paging.curItems;
      // console.log('in prev pagination inside',  this.page);
      this.getNewPage(this.paging.previousItemsLink, false);
    }
    // console.log('in prev pagination out',  this.page);
  }

  /**
   * When user wants to go on next page
   */
  onNextPagination() {
  // console.log('in next pagination',  this.page);
    if (this.page < this.getTotalPagination()) {
      this.currentTotal = this.currentTotal + this.paging.curItems;
      // console.log('in next pagination inside',  this.page);
      this.getNewPage(this.paging.nextItemsLink, true);
    }
    // console.log('in next pagination out',  this.page);
  }

  /**
   * @return total of pagination
   */
  getTotalPagination(): number {
    return Math.ceil(this.paging.totalItems / this.paging.curItems);
  }

  getNewPage(url: string, goForward: boolean) {
    // warn the parent component about the paging (to stop mqtt refresh when not on first page)
    this.pageNumber.emit(this.page);

    // console.log('url for a new page', url);
    if (!!url) {
      this.notificationService.setToDefault();
      this.loadingItems = true;
      this.dataSubscription.unsubscribe();
      this.dataSubscription = this.paginationService.getDataPage(url).subscribe(
        (itemslist) => {
          // console.log('itemsList', itemslist);
          this.tableData = itemslist;
          console.log('this.tableData ' + this.tableData);
          // pagination
          this.paging = this.tableData.paging;
          this.totalPages = this.getTotalPagination();
          if (this.tableData.list.length > 0) {
            this.noDataFound = false;
            goForward ? this.page++ : this.page--;
          } else {
            this.noDataFound = true;
            this.notificationService.showAlert('No items found.', AlertType.WARNING, null);
          }
          this.loadingItems = false;
          this.selectedItems = []; // clear any selection on previous page to avoid unwanted actions on selected items
          this.expandedItems = []; // set expanded items icons to default
        },
        (error) => {
          this.loadingItems = false;
          this.notificationService.showAlert(error, AlertType.ERROR, null);
        });
      this.subscriptions.push(this.dataSubscription);
    }
  }

  /********************************************** DELETING ******************************/
  /**
   * Opens confirmation dialog on Delete button click
   */
  // openDeleteDialog(): void {
  //   const dialogDeleteConfig = new MatDialogConfig();
  //   dialogDeleteConfig.disableClose = false;
  //   dialogDeleteConfig.width        = '350px';
  //   dialogDeleteConfig.height       = '250px';
  //   dialogDeleteConfig.panelClass   = 'panel-modal';
  //   dialogDeleteConfig.restoreFocus = false;

  //   /* Find names */
  //   const itemNames: string[] = [];
  //   // console.log('selectedItems', this.selectedItems);
  //   this.selectedItems.forEach((uid) => {
  //     const itemsList: (ApiUser[] | ApiManager[] | Application[] | Api[]) = this.tableData.list;

  //     if (this.tableConfiguration.detailComponent === 'users') {
  //       // console.log('its users');
  //       const foundItem = (itemsList as ApiUser[]).find((item: ApiUser) => item.uid === uid);
  //       itemNames.push(foundItem.displayName);
  //     } else if (this.tableConfiguration.detailComponent === 'API managers') {
  //       // console.log('its API managers');
  //       const foundItem = (itemsList as ApiManager[]).find((item: ApiManager) => item.uid === uid);
  //       itemNames.push(foundItem.name);
  //     // } else if (this.tableConfiguration.detailComponent === 'applications') {
  //     //   // console.log('its applications');
  //     //   const foundItem = (itemsList as Application[]).find((item: Application) => item.uid === uid);
  //     //   itemNames.push(foundItem.name);
  //     // } else if (this.tableConfiguration.detailComponent === 'apis') {
  //     //   // console.log('its apis');
  //     //   const foundItem = (itemsList as Api[]).find((item: Api) => item.uid === uid);
  //     //   itemNames.push(foundItem.name);
  //     } else if (this.tableConfiguration.detailComponent === 'fsa') {
  //       // console.log('its fsa');
  //       const foundItem = (itemsList as Api[]).find((item: Api) => item.uid === uid);
  //       itemNames.push(foundItem.name);
  //     }
  //   });

  //   // console.log('itemNames', itemNames);
  //   dialogDeleteConfig.data = { names: itemNames.join(', '), uids: this.selectedItems };

  //   this.dialogRef = this.dialog.open(this.deleteAlert, dialogDeleteConfig);

  //   // this.dialogRef.afterClosed().subscribe(result => {
  //   //   console.log('The Delete dialog was closed', result);
  //   // });
  // }

  // deleteItems(uids: string[]) {
  //   if (this.tableConfiguration.detailComponent === 'users') {
  //     uids.forEach(uid => {
  //       const userDeleteSubscr = this.usersService.deleteUser(uid).subscribe(
  //         (ok) => {
  //           this.dialogRef.close();
  //           const userToDelete: ApiUser = (this.tableData.list as ApiUser[]).find((user: ApiUser) => user.uid === uid);
  //           const userIndex = (this.tableData.list as ApiUser[]).indexOf(userToDelete);
  //           this.tableData.list.splice(userIndex, 1);
  //           console.log('Deleted user ', uid);
  //           this.selectedItems = [];
  //           this.expandedItems = [];
  //         },
  //         (error) => {
  //           this.notificationService.showAlert(error, NotificationType.ERROR);
  //       });
  //       this.subscriptions.push(userDeleteSubscr);
  //     });
  //   } else if (this.tableConfiguration.detailComponent === 'API managers') {
  //     uids.forEach(uid => {
  //       const apiManagerDeleteSubscr = this.apiManagersService.deleteApiManager(uid).subscribe(
  //         (ok) => {
  //           this.dialogRef.close();
  //           const apimToDelete: ApiManager = (this.tableData.list as ApiManager[]).find((apim: ApiManager) => apim.uid === uid);
  //           const apimIndex = (this.tableData.list as ApiManager[]).indexOf(apimToDelete);
  //           this.tableData.list.splice(apimIndex, 1);
  //           console.log('Deleted api manager ', uid);
  //           this.selectedItems = [];
  //           this.expandedItems = [];
  //         },
  //         (error) => {
  //           this.notificationService.showAlert(error, NotificationType.ERROR);
  //       });
  //       this.subscriptions.push(apiManagerDeleteSubscr);
  //     });
  //   } else if (this.tableConfiguration.detailComponent === 'fsa') {
  //     uids.forEach(uid => {
  //       const fsaDeleteSubscr = this.apisService.deleteApi(uid).subscribe(
  //         (ok) => {
  //           this.dialogRef.close();
  //           const apiToDelete: Api = (this.tableData.list as Api[]).find((api: Api) => api.uid === uid);
  //           const apiIndex = (this.tableData.list as Api[]).indexOf(apiToDelete);
  //           this.tableData.list.splice(apiIndex, 1);
  //           console.log('Deleted api ', uid);
  //           this.selectedItems = [];
  //           this.expandedItems = [];
  //         },
  //         (error) => {
  //           this.notificationService.showAlert(error, NotificationType.ERROR);
  //       });
  //       this.subscriptions.push(fsaDeleteSubscr);
  //     });
  //   }
  // }

  /**
   * Close Deleting confirmation dialog
   */
  // onNoClick() {
  //   this.dialogRef.close();
  // }

  onPrevPaginationGroup() {
    this.loadingItems = true;
    this.paginating.emit('prev');
  }

  onNextPaginationGroup() {
    this.loadingItems = true;
    console.log('onNextPaginationGroup');
    this.paginating.emit('next');
  }

  onPrevPaginationEvent() {
    this.loadingItems = true;
    this.paginating.emit('prev-event');
  }

  onNextPaginationEvent() {
    this.loadingItems = true;
    this.paginating.emit('next-event');
  }

  goToPrevPagination(target: Element) {
    if (!target.classList.contains('disabled-img')) {
      if (this.tableConfiguration.detailComponent && this.tableConfiguration.detailComponent === 'event-group') {
        this.onPrevPaginationGroup();
      } else if (this.tableConfiguration.detailComponent && this.tableConfiguration.detailComponent === 'event') {
        this.onPrevPaginationEvent();
      } else {
        this.onPrevPagination();
      }
    }
  }

  goToNextPagination(target: Element) {
    if (!target.classList.contains('disabled-img')) {
      if (this.tableConfiguration.detailComponent && this.tableConfiguration.detailComponent === 'event-group') {
        this.onNextPaginationGroup();
      } else if (this.tableConfiguration.detailComponent && this.tableConfiguration.detailComponent === 'event') {
        this.onNextPaginationEvent();
      } else {
        this.onNextPagination();
      }
    }
  }

  onEventOnClick(event: any) {
    this.eventOnClick.emit(event);
  }

  ngOnDestroy(): void {
    this.notificationService.setToDefault();
    if (this.subscriptions !== undefined) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    this.dataSubscription.unsubscribe();
  }
}
